import * as React from "react"
import Svg, { G, Path, Defs, ClipPath } from "react-native-svg"

function SvgComponent() {
  return (
    <Svg
      width={146}
      height={70}
      viewBox="0 0 146 70"
      fill="none"
    >
      <G opacity={0.9} clipPath="url(#clip0_5683_1933)">
        <Path
          stroke="#000"
          strokeWidth={2}
          strokeDasharray="4 4"
          d="M53 49L96 49"
        />
        <G clipPath="url(#clip1_5683_1933)" fill="#1C274C">
          <G opacity={0.5}>
            <Path d="M84.489 29.284c1.05 0 1.797.001 2.364.085.554.081.874.234 1.107.49.268.293.385.521.45.927.073.458.075 1.11.075 2.269 0 .25.184.452.413.452.228 0 .413-.203.413-.452v-.059c0-1.085 0-1.82-.087-2.365-.096-.607-.302-1-.68-1.412-.412-.452-.935-.652-1.581-.747-.628-.093-1.43-.093-2.443-.093h-.031c-.228 0-.413.203-.413.453s.185.452.413.452zM88.898 36.222c.228 0 .413.202.413.452v.058c0 1.085 0 1.82-.087 2.366-.096.606-.302.999-.68 1.412-.412.451-.935.652-1.581.747-.628.092-1.43.092-2.443.092h-.031c-.228 0-.413-.202-.413-.452s.185-.453.413-.453c1.05 0 1.797 0 2.364-.084.554-.082.874-.235 1.107-.49.268-.294.385-.522.45-.928.073-.458.075-1.11.075-2.268 0-.25.184-.452.413-.452zM82.254 28.38h.03c.229 0 .414.202.414.452s-.185.452-.413.452c-1.051 0-1.798.001-2.364.085-.555.081-.874.234-1.107.49-.269.293-.385.521-.45.927-.073.458-.075 1.11-.075 2.269 0 .25-.185.452-.413.452-.228 0-.413-.203-.413-.452v-.059c0-1.085 0-1.82.086-2.365.097-.607.303-1 .68-1.412.413-.452.936-.652 1.582-.747.628-.093 1.43-.093 2.442-.093z" />
          </G>
          <Path d="M83.387 34.11c-.38 0-.689.338-.689.754 0 .417.308.754.689.754.38 0 .689-.337.689-.754 0-.416-.309-.754-.69-.754z" />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M80.021 36.107c-.328-.416-.492-.625-.492-1.243 0-.618.164-.826.492-1.242.655-.831 1.753-1.774 3.366-1.774 1.613 0 2.711.943 3.366 1.774.328.416.492.624.492 1.242s-.164.827-.492 1.243c-.655.831-1.753 1.773-3.366 1.773-1.613 0-2.711-.942-3.366-1.773zm1.85-1.243c0-.916.679-1.659 1.516-1.659s1.515.743 1.515 1.66c0 .916-.678 1.658-1.515 1.658-.837 0-1.516-.742-1.516-1.659z"
          />
        </G>
        <Path
          d="M76.525 31.15c-2.412 0-4.386 2.147-4.386 4.772v1.909h1.754v-1.91c0-1.574 1.184-2.863 2.632-2.863 1.447 0 2.63 1.289 2.63 2.864v1.909h1.755v-1.91c0-2.624-1.974-4.772-4.385-4.772z"
          fill="#424242"
        />
        <Path
          d="M81.787 50.238H71.262c-.965 0-1.754-.859-1.754-1.909v-8.59c0-1.05.79-1.908 1.754-1.908h10.525c.965 0 1.754.859 1.754 1.908v8.59c0 1.05-.79 1.91-1.754 1.91z"
          fill="#FB8C00"
        />
        <Path
          d="M75.209 44.034c0 .38.139.744.385 1.013.247.268.582.419.93.419.35 0 .684-.15.93-.42.248-.268.386-.632.386-1.012s-.138-.743-.385-1.012a1.264 1.264 0 00-.93-.42c-.35 0-.684.152-.93.42a1.498 1.498 0 00-.386 1.012z"
          fill="#C76E00"
        />
        <Path
          d="M13.568 28.038H7.084v23.784h6.484V28.038zM27.498 28.038h-6.485v23.784h6.485V28.038zM41.428 28.038h-6.484v23.784h6.484V28.038zM55.36 28.038h-6.485v23.784h6.484V28.038z"
          fill="#66E6FF"
        />
        <Path
          opacity={0.15}
          d="M13.568 28.038H7.084v4.482h6.484v-4.482z"
          fill="#293133"
        />
        <Path d="M15.116 23.754H5.535v5.78h9.58v-5.78z" fill="#2EC8E6" />
        <Path
          opacity={0.15}
          d="M13.568 47.342H7.084v4.482h6.484v-4.482z"
          fill="#293133"
        />
        <Path d="M15.116 50.33H5.535v7.273h9.58V50.33z" fill="#2EC8E6" />
        <Path
          opacity={0.15}
          d="M27.498 28.038h-6.485v4.482h6.485v-4.482z"
          fill="#293133"
        />
        <Path d="M29.046 23.754h-9.58v5.78h9.58v-5.78z" fill="#2EC8E6" />
        <Path
          opacity={0.15}
          d="M27.498 47.342h-6.485v4.482h6.485v-4.482z"
          fill="#293133"
        />
        <Path d="M29.046 50.33h-9.58v7.273h9.58V50.33z" fill="#2EC8E6" />
        <Path
          opacity={0.15}
          d="M41.428 28.038h-6.484v4.482h6.484v-4.482z"
          fill="#293133"
        />
        <Path d="M42.977 23.754h-9.58v5.78h9.58v-5.78z" fill="#2EC8E6" />
        <Path
          opacity={0.15}
          d="M41.428 47.342h-6.484v4.482h6.484v-4.482z"
          fill="#293133"
        />
        <Path d="M42.977 50.33h-9.58v7.273h9.58V50.33z" fill="#2EC8E6" />
        <Path
          opacity={0.15}
          d="M55.36 28.038h-6.485v4.482h6.484v-4.482z"
          fill="#293133"
        />
        <Path d="M56.907 23.754h-9.581v5.78h9.58v-5.78z" fill="#2EC8E6" />
        <Path
          opacity={0.15}
          d="M55.36 47.342h-6.485v4.482h6.484v-4.482z"
          fill="#293133"
        />
        <Path d="M56.907 50.33h-9.581v7.273h9.58V50.33z" fill="#2EC8E6" />
        <Path
          d="M61.828 22.422L36.942 3.682c-3.452-2.599-7.99-2.599-11.442 0L.614 22.422c-1.138.857-.59 2.826.789 2.826h59.636c1.378 0 1.927-1.969.789-2.826zM56.789 56.108H5.653c-2.323 0-4.206 2.082-4.206 4.65v3.896h59.548v-3.897c0-2.567-1.883-4.648-4.206-4.648z"
          fill="#CCF7FF"
        />
        <Path
          opacity={0.15}
          d="M62.442 64.01H0v3.271h62.442v-3.27z"
          fill="#293133"
        />
        <Path d="M62.442 60.757H0v6.525h62.442v-6.525z" fill="#66E6FF" />
        <Path
          opacity={0.15}
          d="M62.442 64.01H0v3.271h62.442v-3.27z"
          fill="#293133"
        />
        <Path
          d="M31.22 18.702c2.278 0 4.124-2.04 4.124-4.558 0-2.517-1.846-4.558-4.124-4.558-2.277 0-4.124 2.04-4.124 4.558 0 2.517 1.847 4.558 4.124 4.558z"
          fill="#2EC8E6"
        />
        <Path
          opacity={0.15}
          d="M29.35 14.144c0-2.085 1.267-3.842 2.997-4.384a3.76 3.76 0 00-1.126-.174c-2.277 0-4.124 2.041-4.124 4.558 0 2.518 1.846 4.558 4.124 4.558.39 0 .768-.061 1.126-.173-1.73-.542-2.997-2.299-2.997-4.385z"
          fill="#293133"
        />
        <Path
          d="M138.075 65.678H94.869v-55.55h30.861l12.345 12.345v43.205z"
          fill="#75E8FF"
        />
        <Path
          d="M144.247 59.506h-43.205V3.956h30.86l12.345 12.345v43.205z"
          fill="#43CDE8"
        />
        <Path
          d="M114.983 25.145a8.465 8.465 0 100-16.93 8.465 8.465 0 000 16.93z"
          fill="#231F20"
        />
        <Path
          d="M122.048 16.014h-6.402V9.612a7.095 7.095 0 016.402 6.402z"
          fill="#D12200"
        />
        <Path
          d="M114.316 9.618v5.777l-4.727-3.327a7.066 7.066 0 014.727-2.45z"
          fill="#00A1D3"
        />
        <Path
          d="M108.822 13.16l5.777 4.07c.012.008.028 0 .041.014.102.067.22.104.342.108h7.068a7.11 7.11 0 01-12.236 4.256 7.11 7.11 0 01-1.959-4.923c.006-1.24.34-2.456.967-3.525z"
          fill="#7CC05B"
        />
        <Path
          d="M137.228 54.533h-.238V37.074a1.586 1.586 0 00-1.587-1.587h-1.032a1.587 1.587 0 00-1.587 1.587v17.459l-8.529.07v-11.11a1.586 1.586 0 00-1.587-1.587h-1.032a1.589 1.589 0 00-1.587 1.587v11.11h-9.72v-4.761a1.586 1.586 0 00-1.587-1.587h-1.034a1.59 1.59 0 00-1.587 1.587v4.761h-.318a.316.316 0 00-.317.318.315.315 0 00.317.317l31.425-.07a.32.32 0 00.318-.318.32.32 0 00-.318-.317z"
          fill="#231F20"
        />
        <Path
          d="M133.313 36.827a.95.95 0 01.952-.952h1.032a.95.95 0 01.952.952v17.459h-2.936V36.827z"
          fill="#00A1D3"
        />
        <Path
          d="M120.616 43.493a.95.95 0 01.952-.952h1.032a.95.95 0 01.952.952v11.11h-2.936v-11.11z"
          fill="#FF8E5A"
        />
        <Path
          d="M106.755 49.842a.95.95 0 01.952-.952h1.032a.95.95 0 01.952.952v4.761h-2.936v-4.761z"
          fill="#FFBA50"
        />
        <Path
          d="M107.537 33.252h27.171c.547 0 1.072-.055 1.458-.153.387-.097.605-.23.605-.368 0-.139-.218-.271-.605-.37-.386-.097-.911-.152-1.458-.152h-27.171c-.547 0-1.071.055-1.458.153s-.604.23-.604.369c0 .138.217.27.604.368.387.098.911.153 1.458.153zM106.919 35.339h19.019c.383 0 .75-.055 1.021-.153.271-.098.423-.23.423-.369 0-.138-.152-.27-.423-.369a3.142 3.142 0 00-1.021-.153h-19.019c-.383 0-.75.055-1.021.153-.271.098-.423.23-.423.37 0 .138.152.27.423.368.271.098.638.153 1.021.153zM106.172 36.904h9.048a1.2 1.2 0 00.486-.094c.129-.059.201-.278.201-.363 0-.084-.072-.287-.201-.346a1.202 1.202 0 00-.486-.093h-9.048c-.182 0-.356.033-.485.093s-.201.262-.201.346c0 .085.072.304.201.363.129.06.303.093.485.093z"
          fill="#231F20"
        />
        <Path d="M141.932 17.844h-11.573V6.27l11.573 11.573z" fill="#E1F5FE" />
      </G>
      <Defs>
        <ClipPath id="clip0_5683_1933">
          <Path
            fill="#fff"
            transform="matrix(-1 0 0 1 146 0)"
            d="M0 0H146V70H0z"
          />
        </ClipPath>
        <ClipPath id="clip1_5683_1933">
          <Path
            fill="#fff"
            transform="translate(76.774 27.625)"
            d="M0 0H13.2263V14.4777H0z"
          />
        </ClipPath>
      </Defs>
    </Svg>
  )
}

export default SvgComponent
